export default "__VITE_ASSET__DHj15OcN__"